// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import Difficulty from "./difficulty_type";


export default __t.object("GameRecord", {
  id: __t.u64(),
  userId: __t.u64(),
  username: __t.string(),
  countryCode: __t.string(),
  get difficulty() {
    return Difficulty;
  },
  completionTimeMs: __t.u32(),
  completedAt: __t.u64(),
  bbbv: __t.u16(),
  bbbvPerSecond: __t.f32(),
  totalLeftClicks: __t.u32(),
  totalRightClicks: __t.u32(),
  totalChords: __t.u32(),
  effectiveClicks: __t.u32(),
  ioe: __t.f32(),
  rqp: __t.f32(),
  boardWidth: __t.u8(),
  boardHeight: __t.u8(),
  minesCount: __t.u16(),
  gameModeId: __t.u8(),
  isRanked: __t.bool(),
});


